<template>
    <admin-layout class="element-edit" v-if="form">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1 class="mb-2">
                        {{ form.name }}
                    </h1>
                    <h6 class="text-muted">
                        <strong>{{ type_name }}</strong> /
                        {{ form.name }}
                    </h6>
                </div>
                <hr class="mb-0">
            </template>

            <section class="px-3 py-4 form">
                <form action="" @submit.prevent="save()" autocomplete="off">

                    <div class="form-group">
                        <label>Title</label>
                        <input type="text" class="form-control form-control-lg" v-model="form.name">
                        <error-line field="name"/>
                    </div>

                    <div class="form-group">
                        <label>Handle</label>
                        <input type="text" class="form-control form-control-lg" v-model="form.handle">
                        <error-line field="handle"/>
                    </div>

                    <hr class="my-4">

                    <h5>Theming</h5>

                    <div class="form-group">
                        <label>Logo</label>
                        <file-uploader v-model="theme_logo" storage-path="tenant" />
                        <error-line field=""/>
                    </div>

                    <div class="form-group">
                        <label>Background</label>
                        <file-uploader v-model="theme_background" storage-path="tenant" />
                        <error-line field="file"/>
                    </div>

                    <div class="form-group">
                        <label>Modules</label>
                        <div class="form-check">
                            <div v-for="module in modules">
                                <label :for="module.name">
                                    <input type="checkbox" :id="module.name" class="form-check-input" :value="module.id" v-model="form.selected_modules"/>
                                    {{ module.name }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Embed</label>
                        <textarea class="form-control"
                                  v-model="embed"
                                  placeholder="Enter a embed"></textarea>
                    </div>

                    <div class="form-group">
                        <button type="submit"
                                class="btn btn-primary">Save</button>
                    </div>

                </form>
            </section>


        </app-content-pane>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import ErrorLine from "@/Components/Common/ErrorLine";
import FileUploader from "@/Components/Common/FileUploader";
import uploads from "@/mixins/uploads";
import Label from "../../Jetstream/Label.vue";

export default {
    name: "Edit",
    components: {Label, AdminLayout, AppContentPane, ErrorLine, FileUploader},
    props: ['tenant', 'modules'],
    mixins: [uploads],

    data(){
        return {
            is_busy: false,
            form: null
        }
    },

    computed: {
        theme_logo: {
            get(){
                return this.form?.meta?.logo;
            },
            set(val){
                if( !this.form.meta ) this.form.meta = {};
                this.form.meta.logo = val;
            }
        },
        theme_background: {
            get(){
                return this.form?.meta?.theme?.background;
            },
            set(val){
                if( !this.form.meta ) this.form.meta = {};
                if( !this.form.meta.theme ) this.form.meta.theme = {};
                this.form.meta.theme.background = val;
            }
        },
        embed: {
            get(){
                return this.form?.meta?.embed;
            },
            set(val){
                if( !this.form.meta ) this.form.meta = {};
                this.form.meta.embed = val;
            }
        }
    },

    methods:{

        save(){

            this.is_busy = true;

            if( this.tenant ){
                this.form
                    .transform(data => ({...data, _method: 'put'}))
                    .post(this.route('tenant.update', {tenant: this.tenant.id, ...this.global_url_params}), {
                        forceFormData: true,
                    });
            } else {
                this.form.post(this.route('tenant.store', {...this.global_url_params}), {
                    forceFormData: true,
                });
            }


        },
    },

    mounted() {

        if( this.tenant ){
            this.form = this.$inertia.form({
                name: this.tenant.name,
                handle: this.tenant.handle,
                meta: this.tenant.meta,
                selected_modules: this.tenant.modules.map(m => m.id)
            });
        }else{
            this.form = this.$inertia.form({
                name: 'Unnamed Tenant',
                handle: 'unnamed-tenant',
                meta: {
                    logo: null,
                    theme: {
                        bg: '#fff9e0',
                        color: '#08111a',
                        background: null,
                    },
                },
                selected_modules: []
            });
        }


        if( this.tenant ){
            this.setTitle( `Edit "${this.tenant.name}" Tenant` );
        }else{
            this.setTitle( `Create Tenant` );
        }

    }


}
</script>

<style lang="scss" scoped>
.preview{
    display: block;
    margin: 0.6rem 0;
    width: 260px;
    height: 260px;
    object-fit: cover;
}
.form{
    max-width: 800px;
}

textarea{
    min-height: 240px;
}
</style>
